module.exports = __webpack_public_path__ + "natural.svg?a9fc82b29db83d257abfc3d912952cd6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/natural.svg
// module id = 95
// module chunks = 0